import React, { useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import SignIn from "./Pages/AuthenticationPages/SignIn/SignIn";
import "./App.css";
import HomePage from "./Pages/HomePage/HomePage";
// import Dashboard from "./Pages/Dashboard/Dashboard";
import { useEffect, createContext } from "react";
import RouteTracker from "./Pages/RouteTracker/RouteTracker";
import SignUp from "./Pages/AuthenticationPages/SignUp/SignUp";
import { useSession } from "./authentications/SessionContext";
// import Orders from "./Pages/Orders/Orders";
// import Tasks from "./Pages/CRM/CRM";
// import Products from "./Pages/Products/Products";
// import Accounting from "./Pages/Accounting/Accounting";
// import ContactCenter from "./Pages/ContactCenter/ContactCenter";
// import OrderRefund from "./Components/OrderRefund/OrderRefund";
// import Warehouse from "./Pages/Warehouse/Warehouse";
// import Setting from "./Pages/Setting/Setting";
import ResetPassword from "./Pages/AuthenticationPages/ResetPassword/ResetPassword";
import Email from "./Pages/AuthenticationPages/Email/Email";
import VerifyEmail from "./Pages/AuthenticationPages/VerifyEmail/VerifyEmail";
import PublicRouter from "./Components/RouteAuth/PublicRouter";
// import Contacts from "./Pages/Contacts/Contacts";
import TableLoader from "./Components/Loaders/TableLoader";
import { ToastContainer } from "react-toastify"; // Import ToastContainer
import "react-toastify/dist/ReactToastify.css"; // Import Toastify styles
// import Users from "./Pages/Users/Users";
// import Company from "./Pages/Company/Company";
// import Subscription from "./Pages/IonSubscription/Subscription";
import {
  primaryColor,
  textColor,
  backgroundColor,
  borderColor,
} from "./utilities/colors";
import { ThemeProvider } from "styled-components";
// import Brands from "./Pages/Brands/Brands";
// import Categories from "./Pages/Categories/Categories";
import useRoutes from "./CustomHooks/useRoutes";
import {
  SIDEBAR_OPTIONS_LIST,
  VTEX_SIDEBAR_OPTIONS_LIST,
} from "./utilities/constants";
import PageNotFound from "./Pages/PageNotFound/PageNotFound";
import OnboardingInfo from "./Pages/AuthenticationPages/OnoardingInfo/OnboardingInfo";
import TestPage from "./Pages/TempPages/testPage";

const UserContext = createContext();
function App() {
  // const useEffectHasRunRef = useRef(false);
  const [theme, setTheme] = useState(null);
  const { authenticated, handleCheckSession, themeChanged, sessionInfo } =
    useSession();
  const { isVTEX, VtexAdmin, ionAdmin } = sessionInfo;
  const AuthGuard = ({ isAllowed, redirectTo = "/" }) => {
    return isAllowed ? <Outlet /> : <Navigate to={redirectTo} replace />;
  };

  // const NoPage = () => {
  //   localStorage.removeItem("lastVisitedRoute");
  //   return <Navigate replace to="/signin" />;
  // };
  const IndexPage = () => {
    if (
      window.location.pathname === "/" ||
      // window.location.pathname === "/" ||
      window.location.pathname === "/"
    ) {
      return <Navigate replace to="/singin" />;
    }
    return <Outlet />;
  };

  const { renderRoute } = useRoutes(themeChanged);

  useEffect(() => {
    handleCheckSession();
  }, []);

  useEffect(() => {
    if (themeChanged) {
      setTheme({
        primaryColor,
        textColor,
        backgroundColor,
        borderColor,
      });
      return;
    }
    setTheme(null);
  }, [themeChanged]);
  return (
    <TableLoader isLoading={authenticated === null || theme === null}>
      <ThemeProvider theme={theme}>
        <BrowserRouter basename="merchant">
          <UserContext.Provider value={{ authenticated }}>
            <ToastContainer />
            <RouteTracker />
            <Routes>
              <Route path="/" element={<IndexPage />}>
                <Route path="" element={<Outlet />}>
                  <Route path="" element={<PublicRouter />}>
                    <Route path="signin" element={<SignIn />} />
                    <Route
                      path="signup"
                      element={VtexAdmin || ionAdmin ? <SignUp /> : <SignIn />}
                    />
                    {/* <Route path="test" element={<TestPage />} /> */}
                    <Route path="signup-info" element={<OnboardingInfo />} />
                    <Route path="resetPassword" element={<ResetPassword />} />
                    <Route path="email" element={<Email />} />
                    <Route path="Verify_email" element={<VerifyEmail />} />
                  </Route>

                  <Route path="/homepage" element={<HomePage />}>
                    {renderRoute(
                      isVTEX ? VTEX_SIDEBAR_OPTIONS_LIST : SIDEBAR_OPTIONS_LIST
                    )}
                  </Route>
                  {/* <Route path="homepage" element={<HomePage />}>
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="crm" element={<Tasks />} />
                    <Route path="orders" element={<Orders />} />
                    <Route path="products" element={<Products />} />
                    <Route path="categories" element={<Categories />} />
                    {isVTEX ? (
                      <Route path="brands" element={<Brands />} />
                    ) : (
                      <Route path="dashboard" element={<Dashboard />} />
                    )}
                    <Route path="contacts" element={<Contacts />} />
                    <Route path="accounting" element={<Accounting />} />
                    <Route path="ContactCenter" element={<ContactCenter />} />
                    <Route path="orderrefund" element={<OrderRefund />} />
                    <Route path="warehouse" element={<Warehouse />} />
                    <Route path="setting" element={<Setting />} />
                    <Route path="SubscriptionCenter" element={<Setting />} />
                    <Route path="Users" element={<Users />} />
                    <Route path="Company" element={<Company />} />
                    <Route path="subscription" element={<Subscription />} />
                  </Route> */}
                </Route>
              </Route>
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </UserContext.Provider>
        </BrowserRouter>
      </ThemeProvider>
    </TableLoader>
  );
}

export default App;
